import { Drawer } from 'antd';
import { RowListSkeleton } from '../../../shared/components/RowListSkeleton';
import type { IntegrationsOverview } from '../hooks/use-integrations-overview';
import { INTEGRATION_KIND_LABELS, type IntegrationKind } from '../integrations.paths';
import { IntegrationCatalogue } from './IntegrationCatalogue';

/** "Add integration" on a tab: the catalogue of that tab's kind. */
export function AddIntegrationSheet({ kind, overview, onClose }: { kind: IntegrationKind; overview: IntegrationsOverview; onClose: () => void }) {
  return (
    <Drawer open onClose={onClose} title={`Add ${INTEGRATION_KIND_LABELS[kind]}`} size={520}>
      {overview.isCatalogueLoading ? (
        <RowListSkeleton label="Loading the catalogue" />
      ) : (
        <IntegrationCatalogue
          kind={kind}
          smsProviders={overview.installableSms}
          whatsappProviders={overview.installableWhatsapp}
          gpsAdapters={overview.gpsAdapters}
        />
      )}
    </Drawer>
  );
}
